module.exports = __webpack_public_path__ + "static/img/uaes-slogan.169a1104.png";